import { useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '../../components/PageHeader/PageHeader'
import { PageLoadingShell } from '../PageLoadingShell/PageLoadingShell'
import type { ConfirmDeleteEntityPageProps } from './ConfirmDeleteEntityPage.types'
import './ConfirmDeleteEntityPage.css'

export function ConfirmDeleteEntityPage({
  entityLabel,
  title,
  cancelTo,
  onConfirm,
  isLoading,
  loadError,
}: ConfirmDeleteEntityPageProps) {
  const [isDeleting, setIsDeleting] = useState(false)
  const [deleteError, setDeleteError] = useState<string | null>(null)

  async function handleConfirm() {
    setIsDeleting(true)
    setDeleteError(null)
    try {
      await onConfirm()
    } catch (e) {
      setDeleteError(e instanceof Error ? e.message : 'Failed to delete')
      setIsDeleting(false)
    }
  }

  return (
    <PageLoadingShell
      loadingLabel={entityLabel.toLowerCase()}
      isLoading={isLoading}
      error={loadError}
    >
      <PageHeader title={`Delete ${title}`} />
      <section
        className="content-card content-card--padded confirm-delete"
        aria-label={`Delete ${title}`}
      >
        {deleteError && (
          <div className="alert alert-danger" role="alert">
            <strong>Error:</strong> {deleteError}
          </div>
        )}

        <p className="confirm-delete__question">
          Are you sure you want to delete <strong>{title}</strong>?
        </p>
        <div className="confirm-delete__actions">
          <Link to={cancelTo} className="btn btn-outline-secondary btn-sm">
            Cancel
          </Link>
          <button
            className="btn btn-danger btn-sm"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            )}
            Delete
          </button>
        </div>
      </section>
    </PageLoadingShell>
  )
}
